module.exports = __webpack_public_path__ + "media/images/countrysquared/pk-900e464302406b3b563a86a0433e0d71.svg";